export type Locale = typeof locales[number];
export const locales = ["en", "fr"] as const;
export const defaultLocale = "en" satisfies Locale;
export const localeNames = {
  "en": "English",
  "fr": "Français",
} satisfies { [k in Locale]: string };
export const localeEntries = Object.entries(localeNames) as [Locale, string][];


export const defaultAppName = "Zapptax";
export const defaultSiteTitle = "Zapptax - Tax-free shopping on your mobile";
export const defaultMetaDescription = "The easiest way to get your tax refund on all your purchases in Europe.";


export const links = {
  download: {
    appStore: "https://apps.apple.com/us/app/zapptax-shop-tax-free/id1254346990",
    playStore: "https://play.google.com/store/apps/details?id=com.zapptax.zapptax",
  },

  social: {
    instagram: "https://www.instagram.com/zapptax",
    facebook: "https://www.facebook.com/Zapptax",
    linkedIn: "https://www.linkedin.com/company/zapptax",
    redNote: "https://www.xiaohongshu.com/user/profile/617ea0870000000002025b8a",
    weChat: "weixin://profile/zapptax",
    weChat2: "http://weixin.qq.com/r/mp/YERNVYbEndvircI29xFy",
  },

  phone: {
    retail: {
      france: "+33 1 89 71 60 35",
      belgium: "+32 2 588 07 22",
      spain: "+34 919 49 62 31",
    },

    traveler: {
      france: "+33 1 78 90 04 42",
      belgium: "+32 2 880 59 12",
      spain: "+34 910 607 358",
      uk: "+44 207 04 82 473",
    },
  },

  email: {
    support: "support@zapptax.com",
  },

  jobs: {
    en: "https://www.welcometothejungle.com/en/companies/zapptax",
    fr: "https://www.welcometothejungle.com/fr/companies/zapptax",
  },
};
